import { InfinityMark } from "./Wordmark";
import { SYSTEM_DESCRIPTOR } from "@/lib/looseend/pee";

/**
 * First-use examples. These are things a person might actually say — not
 * product modes. Clicking one goes through the ordinary send path; the
 * backend decides what kind of problem it is.
 */
const EXAMPLES = [
  "I have a bill I keep putting off",
  "I'm waiting to hear back from someone",
  "There's something important I've been avoiding",
] as const;

export function EmptyConversationState({
  onSuggestion,
}: {
  onSuggestion: (prompt: string) => void;
}) {
  return (
    <div className="content-column flex flex-col items-center py-6 text-center sm:py-12">
      <InfinityMark className="size-11 text-2xl" />
      <p className="mt-2 hidden text-[11px] tracking-[0.01em] text-muted-foreground sm:block">
        {SYSTEM_DESCRIPTOR}
      </p>
      <h1 className="mt-5 text-[22px] font-semibold tracking-tight text-foreground sm:text-[26px]">
        What&rsquo;s hanging over you?
      </h1>
      <p className="mt-2 max-w-md text-[15px] leading-relaxed text-foreground/90">
        Tell LooseEnd what&rsquo;s unresolved.
      </p>
      <p className="mt-1.5 max-w-md text-[13px] leading-relaxed text-muted-foreground/80">
        It can be unfinished, overdue, uncertain, or waiting on someone else.
      </p>

      <ul className="mt-6 flex flex-wrap justify-center gap-2" aria-label="Examples">
        {EXAMPLES.map((example) => (
          <li key={example}>
            <button
              type="button"
              onClick={() => onSuggestion(`${example}.`)}
              className="rounded-full border border-border bg-card px-3.5 py-2 text-[13px] text-foreground transition-colors hover:bg-surface"
            >
              &ldquo;{example}&rdquo;
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
